/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import costHintBoxStyle from "./costHintBoxStyle";
import {Box} from "@mui/material";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type CostHintBoxProps = {
    settlement: AbstractCase;
}

const CostHintBox = ({ settlement }: CostHintBoxProps) => {
  return (
    <Box sx={costHintBoxStyle.insuranceBox}>
      <p>
        <strong>Die Prüfung der Kündigung ist kostenlos und völlig unverbindlich!</strong>
      </p>
      {settlement.legalExpenseInsurance && (
        <p>Ihre Rechtsschutzversicherung trägt auch im Anschluss an die Prüfung alle Kosten. Wir übernehmen zudem den Selbstbehalt für Sie!</p>
      )}
      {settlement.noWinNoFee && !settlement.legalExpenseInsurance && (
        <p>Sie zahlen erst, wenn Sie durch uns Klage gegen die Kündigung einreichen möchten und auch dann nur bei Erfolg!</p>
      )}
    </Box>
  );
};

export default CostHintBox;
